import React from 'react'
import MaterialSymbol from '../material-symbol'

const KeyboardBackspace = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="keyboard_backspace" {...props} />
))

KeyboardBackspace.displayName = 'KeyboardBackspace'

export default KeyboardBackspace
